export const techniciansHeaderElements = [
  { label: "Nombre y apellido", value: "nombreApellido", align: "inherit" },
  { label: "Estado", value: "estado", align: "inherit" },
];
